import React from 'react';
import { animated } from 'react-spring';
import { PapiDeviation } from '@wix/da-papi-types';
import Slide from './Slide';
import { SLIDESHOW_HEIGHT } from './DeviationSlideshow';
import { useSlideAnimation } from './hooks';
import { SlideAnimationState } from './types';
import s from './DeviationSlideshow.scss';

interface Props {
  items: PapiDeviation[];
  containerWidth: number;
  useCoverMode: boolean;
  animationState: SlideAnimationState;
}

const Track: React.FC<Props> = ({
  items,
  containerWidth,
  useCoverMode,
  animationState,
}) => {
  const transitions = useSlideAnimation(animationState);

  // Immediate siblings will be preloaded for performance reasons
  const { index: currentIndex } = animationState;
  const preloadIndexes = items.reduce<number[]>((acc, _, index) => {
    if (currentIndex !== index && Math.abs(currentIndex - index) < 2) {
      acc.push(index);
    }
    return acc;
  }, []);

  const renderSlide = (index, visible = true) => (
    <Slide
      key={index}
      deviation={items[index]}
      containerWidth={containerWidth}
      useCoverMode={useCoverMode}
      active={currentIndex === index}
      visible={visible}
    />
  );

  return (
    <div className={s['track']} style={{ height: SLIDESHOW_HEIGHT }}>
      {transitions.map(({ item: index, key, props }) => (
        <animated.div key={key} style={props}>
          {renderSlide(index)}
          {items.length > 1 && (
            <div className={s['slide-counter']}>
              {`${index + 1}/${items.length}`}
            </div>
          )}
        </animated.div>
      ))}
      {preloadIndexes.map(index => renderSlide(index, false))}
    </div>
  );
};

export default Track;
